class PriceRange extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const that = this;
    const fromSlider = that.querySelector('#fromRange');
    const toSlider = that.querySelector('#toRange');
    const fromInput = that.querySelector('#fromValue');
    const toInput = that.querySelector('#toValue');
    that.fillSlider(fromSlider, toSlider, '#999', 'rgb(var(--highlight-color))', toSlider);
    that.setToggleAccessible(toSlider);
    fromSlider.addEventListener('input', () => {that.controlFromSlider(fromSlider, toSlider, fromInput)});
    toSlider.addEventListener('input', () => {that.controlToSlider(fromSlider, toSlider, toInput)});
    fromInput.addEventListener('input', () => {that.controlFromInput(fromSlider, fromInput, toInput, toSlider)});
    toInput.addEventListener('input', () => {that.controlToInput(toSlider, fromInput, toInput, toSlider)});

    //handle input on ranges and number inputs
    fromSlider.addEventListener('input', that.debounce(() => {that.handleFromInput(fromInput);}, 500));
    toSlider.addEventListener('input', that.debounce(() => {that.handleToInput(toInput);}, 500));
    fromInput.addEventListener('input', that.debounce(() => {that.handleFromInput(fromInput);}, 500));
    toInput.addEventListener('input', that.debounce(() => {that.handleToInput(toInput);}, 500));
  }

  debounce(fn, wait) {
    let that = this;
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(that, args), wait);
    };
  }

  handleFromInput(fromInput) {
    let that = this;
    const section = that.closest('[id^="shopify-section-"]');
    section.classList.add('loading');
    const sectionId = section.querySelector('[data-section-id]').dataset.sectionId;
    that.value = that.getAttribute('name');
    if(!!that.value){
      that.min = Number(fromInput.value);
      const current_path = location.pathname;
      let params = (new URL(document.location)).searchParams;
      if(!!that.min && that.min > 0){
        params.set(that.value+'.gte', that.min);
      } else{
        params.delete(that.value+'.gte');
      }
      const newURL = `${current_path}?${params.toString()}`;
      history.replaceState(null, "", newURL);
      params.set('section_id', sectionId);
      const search = params.toString();
      const sectionApiUrl = `${current_path}?${search}`;
      that.rerenderSection(section, sectionApiUrl);
    }
  }

  handleToInput(toInput) {
    let that = this;
    const section = that.closest('[id^="shopify-section-"]');
    section.classList.add('loading');
    const sectionId = section.querySelector('[data-section-id]').dataset.sectionId;
    that.value = that.getAttribute('name');
    if(!!that.value){
      that.max = Number(toInput.value);
      const current_path = location.pathname;
      let params = (new URL(document.location)).searchParams;
      if(!!that.max){
        params.set(that.value+'.lte', that.max);
      } else {
        params.delete(that.value+'.lte');
      }
      const newURL = `${current_path}?${params.toString()}`;
      history.replaceState(null, "", newURL);
      params.set('section_id', sectionId);
      const search = params.toString();
      const sectionApiUrl = `${current_path}?${search}`;
      that.rerenderSection(section, sectionApiUrl);
    }
  }

  controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const that = this;
    const [from, to] = that.getParsed(fromInput, toInput);
    that.fillSlider(fromInput, toInput, '#999', 'rgb(var(--highlight-color))', controlSlider);
    if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
    } else {
        fromSlider.value = from;
    }
  }
      
  controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const that = this;
    const [from, to] = that.getParsed(fromInput, toInput);
    that.fillSlider(fromInput, toInput, '#999', 'rgb(var(--highlight-color))', controlSlider);
    that.setToggleAccessible(toInput);
    if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
    } else {
        toInput.value = from;
    }
  }

  controlFromSlider(fromSlider, toSlider, fromInput) {
    const that = this;
    const [from, to] = that.getParsed(fromSlider, toSlider);
    that.fillSlider(fromSlider, toSlider, '#999', 'rgb(var(--highlight-color))', toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromInput.value = from;
    }
  }

  controlToSlider(fromSlider, toSlider, toInput) {
    const that = this;
    const [from, to] = that.getParsed(fromSlider, toSlider);
    that.fillSlider(fromSlider, toSlider, '#999', 'rgb(var(--highlight-color))', toSlider);
    that.setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }
  }

  getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.max-to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
      ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
      ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} 100%)`;
  }

  setToggleAccessible(currentTarget) {
    const that = this;
    const toSlider = that.querySelector('#toRange');
    if (Number(currentTarget.value) <= 0 ) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

  rerenderSection(section, url){
    let that = this;
    fetch(url, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => {
      let template = document.createElement('template');
      template.innerHTML = data.trim();
      let firstChild = template.content.firstChild;
      section.querySelectorAll('clever-dropdown').forEach(dropdown => {
        const dropdown_id = dropdown.id;
        const new_dropdown = firstChild.querySelector(`#${dropdown_id}`);
        if(!!new_dropdown){
          new_dropdown.setAttribute('state', dropdown.getAttribute('state'));
        }
      });
      section.querySelectorAll('#filter-drawer').forEach(drawer => {
        const drawer_id = drawer.id;
        const new_drawer = firstChild.querySelector(`#${drawer_id}`);
        if(!!new_drawer){
          new_drawer.setAttribute('state', drawer.getAttribute('state'));
        }
      });
      section.querySelectorAll('filter-accordion').forEach(accordion => {
        const accordion_id = accordion.id;
        const new_accordion = firstChild.querySelector(`#${accordion_id}`);
        if(!!new_accordion){
          new_accordion.setAttribute('state', accordion.getAttribute('state'));
        }
      });
      section.replaceWith(firstChild);
      window.initLazyImages();
      window.dispatchEvent(new Event('collection:rerender'));
    }).catch(function(err) {
      if(!!section)
        section.classList.remove('loading');
      console.error(err);
    });
  }
}
customElements.define('price-range', PriceRange);
